<template>
    <div class="animated fadeIn apinvfrm">        
        <b-card>
            <div slot="header">
                AP TAX Correction Form
                <div class="card-header-actions">
                <button  v-if="saveEnabled" class="btn btn-primary mr-1" @click="save()"><i class="fa fa-save"></i> Save</button>
                  <button class="btn btn-danger mr-1" @click="close()" > <i class="fa fa-close"></i> Close</button>
                </div>
            </div>
            <b-row>
                <b-col lg="8">
                    <b-form-row>
                        <b-col lg="6">
                        <b-input-group>
                            <b-input-group-prepend><label>AP. Number</label></b-input-group-prepend>
                            <b-form-input v-model="model.nomor" readonly :state="!$v.model.apinvkey.$error"></b-form-input>
                            <b-input-group-append>
                                <b-btn text="Button" @click="lkuApShow=true" id="apInvoice">
                                    <i class="fa fa-search"></i>
                                </b-btn>
                            </b-input-group-append>
                        </b-input-group>
                        </b-col>
                        <b-col lg="6">                            
                        <b-input-group>
                            <b-input-group-prepend><label>Trx. Date</label></b-input-group-prepend>
                            <b-form-input v-model="model.tanggal" type="date" disabled></b-form-input>                                        
                        </b-input-group>
                        </b-col>
                    </b-form-row >                      
                    <b-input-group >
                        <b-input-group-prepend><label>Supplier/Vendor</label></b-input-group-prepend>
                        <b-form-input readonly v-model="model.vendorinfo" style="width:40% !important;" disabled></b-form-input>
                        <b-input-group-prepend><span class="ml-1 pt-2">PO#</span></b-input-group-prepend>
                        <b-form-input readonly v-model="model.po" disabled></b-form-input>
                    </b-input-group>
                    <b-input-group>
                        <b-input-group-prepend><label>Description</label></b-input-group-prepend>
                        <b-form-input  v-model="model.uraian" disabled></b-form-input>
                    </b-input-group>
                    <b-row>
                        <b-col cols="7" >
                            <b-input-group >
                                <b-input-group-prepend><label >Invoice Amount</label></b-input-group-prepend>
                                <b-input-group-prepend>
                                <span class="input-group-text" style="width:60px;">{{model.matauang}}</span>
                                </b-input-group-prepend>
                                <my-number class="form-control text-right" separator="," v-model="model.totalinv" :precision="2" disabled ></my-number>
                            </b-input-group>
                        </b-col>
                        <b-col lg="5">                            
                            <b-input-group >
                                <b-input-group-prepend><label>Invoice DP/Termin</label></b-input-group-prepend>
                                <b-form-select v-model="model.tagihandp" :plain="true" :options="YesNo" disabled></b-form-select>
                                <b-input-group-append > <span class="input-group-text">Termin #</span></b-input-group-append>
                                <b-form-select  v-model="model.termin" :plain="true" :options="invoiceTerms" disabled></b-form-select>
                            </b-input-group>
                        </b-col>
                    </b-row>
                </b-col>
                <b-col lg="4">
                    <b-input-group >
                        <b-input-group-prepend><label>Cash Flow</label></b-input-group-prepend>
                        <b-form-input readonly v-model="model.cashflow" ></b-form-input>
                    </b-input-group>
                    <v-dim :model="model" ></v-dim>
                </b-col>
            </b-row>
            <b-card no-body class="mb-1">
                <b-table
                    class="mb-0"
                    ref="tblApLines"
                    outlined striped hover small
                    style="font-size:smaller;" 
                    :items="apLines.items"
                    :fields="apLines.fields"
                    :current-page="apLines.page"
                    :per-page="apLines.limit"
                    >
                        <template v-slot:cell(index)="data">
                        {{data.index + 1}}
                        </template>
                        <template v-slot:cell(quantity)="data">
                            {{data.item.quantity}} {{data.item.unitsize}}
                        </template>
                        <template v-slot:cell(unitprice)="data">
                        {{data.item.unitprice|numFormat}}
                        </template>
                        <template v-slot:cell(nilai)="data">
                        {{data.item.nilai|numFormat}}
                        </template>
                        <template v-slot:cell(nilaippn)="data">
                        {{data.item.nilaippn|numFormat}}
                        </template>
                        <template v-slot:cell(nilaidue)="data">
                        {{data.item.nilaidue|numFormat}}
                        </template>
                        <template v-slot:cell(pasalpph)="data">
                            <span v-if="(data.item.pph)">
                                {{data.item.pasalpph}} {{data.item.pph|numFormat}}%
                            </span>
                        </template>

                        <template v-slot:cell(action)="data">
                            <div class="text-center">
                            <a href="javascript:void(0)" @click="editApLines(data.item,data.toggleDetails)">
                                <i class="fa fa-pencil"></i>
                            </a>
                            |
                            <a href="javascript:void(0)" class="text-danger" @click="delApLines(data.index)">
                                <i class="fa fa-trash"></i>
                            </a>
                            </div>
                        </template>
                    <template v-slot:row-details="row">
                    <b-card class="row-details-form">
                      <b-tabs card v-model="tabIndex">
                        <b-tab title="INVOICE ITEM DETAIL" active>
                            <b-row h-align="center">
                                <b-col lg="6" xl="6" class="pl-0">
                                    <b-input-group>
                                        <b-input-group-prepend><label>Description</label></b-input-group-prepend>
                                        <b-form-input v-model="apLinesObj.uraian_dt" disabled ></b-form-input>
                                    </b-input-group>
                                    <b-input-group>
                                        <b-input-group-prepend><label>GL Account#</label></b-input-group-prepend>
                                        <b-form-input v-model="apLinesObj.glAccount" disabled></b-form-input>
                                    </b-input-group>
                                    <b-row no-gutters>
                                        <b-col lg="6">
                                            <b-input-group>
                                                <b-input-group-prepend><label>Quantity</label></b-input-group-prepend>
                                                <b-form-input v-model="apLinesObj.quantity" disabled type="number"></b-form-input>
                                                <b-input-group-prepend><span class="input-group-text" style="width:70px;">Unit Size</span></b-input-group-prepend>
                                                <b-form-input v-model="apLinesObj.unitsize" disabled></b-form-input>
                                            </b-input-group>
                                        </b-col>
                                        <b-col lg="6">
                                            <b-input-group>
                                                <b-input-group-prepend><label>Unit Price</label></b-input-group-prepend>
                                                <b-input-group-prepend>
                                                <span class="input-group-text" style="width:60px;">{{model.matauang}}</span>
                                                </b-input-group-prepend>
                                                <my-number class="form-control text-right" v-model="apLinesObj.unitprice" :precision="2" disabled></my-number>
                                            </b-input-group>
                                        </b-col>
                                    </b-row>
                                </b-col>
                                <b-col lg="6" xl="6" class="pl-0">
                                    <b-form-row>
                                        <b-col xl="10">                            
                                            <b-input-group>
                                                <b-input-group-prepend><label>Net Amount</label></b-input-group-prepend>
                                                <b-input-group-prepend>
                                                <span class="input-group-text" style="width:60px;">{{model.matauang}}</span>
                                                </b-input-group-prepend>
                                                <my-number class="form-control text-right" v-model="apLinesObj.nilai" :precision="2" disabled></my-number>
                                            </b-input-group>
                                        </b-col>
                                        <b-col xl="2">                            
                                            <b-form-checkbox id="chkPPN" class="ml-1 mt-2 text-left" v-model="apLinesObj.kenappnAdj" value=1 unchecked-value=0 @change="calcTaxes()" >PPN(VAT)</b-form-checkbox>
                                        </b-col>
                                    </b-form-row >                      

                                    <b-form-row v-if="(apLinesObj.kenappnAdj==1)">
                                        <b-col xl="6">
                                            <b-input-group>
                                                <b-input-group-prepend><label>Tarif DPP</label></b-input-group-prepend>
                                                <b-form-input v-model="apLinesObj.dppnlainAdj" @change="calcTaxes()"></b-form-input>
                                                <b-input-group-append><span class="input-group-text">% </span></b-input-group-append>
                                                <b-input-group-append><span class="pt-2"><strong> &nbsp; * Net Amount</strong> </span></b-input-group-append>
                                            </b-input-group>
                                        </b-col>
                                        <b-col xl="4">                            
                                            <b-input-group>
                                                <b-input-group-prepend><span class="p-2">Tarif PPN</span></b-input-group-prepend>
                                                <b-form-input v-model="model.ppn" @change="calcTaxes()"  type="number" v-b-tooltip.hover :title="model.ppn"></b-form-input>
                                                <b-input-group-append><span class="input-group-text">%</span></b-input-group-append>
                                            </b-input-group>
                                        </b-col>
                                    </b-form-row >         
                                    <b-form-row>
                                        <b-col lg="5">
                                            <b-input-group>
                                                <b-input-group-prepend><label>PPH akan dipotong</label></b-input-group-prepend>
                                                <b-form-select v-model="apLinesObj.pasalpphAdj" :plain="true" :options="lookupPPH" :state="!$v.apLinesObj.pasalpphAdj.$error" ></b-form-select>
                                            </b-input-group>
                                        </b-col>
                                        <b-col lg="7">
                                            <b-input-group>
                                                <b-input-group-prepend><span class="p-2">Kode Objek</span></b-input-group-prepend>
                                                <b-form-input readonly v-model="apLinesObj.penghasilaninfo" style="font-size:0.78rem !important;" ></b-form-input>
                                                <b-input-group-append>
                                                <b-btn text="Button" @click="lkuObjekpphShow=true" >
                                                    <i class="fa fa-search"></i>
                                                </b-btn>
                                                </b-input-group-append>
                                            </b-input-group>

                                        </b-col>

                                    </b-form-row >                                                              
                                    <b-row no-gutters >
                                        <b-col lg="5">
                                            <b-input-group>
                                                <b-input-group-prepend><label>Tarif PPH</label></b-input-group-prepend>
                                                <b-form-input v-model="apLinesObj.pphAdj" @change="calcTaxes()" type="number" v-b-tooltip.hover :title="apLinesObj.pphAdj"></b-form-input>
                                                <b-input-group-append><span class="input-group-text">%</span></b-input-group-append>
                                            </b-input-group>                                          
                                        </b-col>
                                        <b-col lg="7">
                                            <b-input-group>
                                                <b-form-select style="font-size:0.78rem !important;"  v-model="calcPPh" :plain="true" :options="calcuationPPH" @change="calcTaxes()" ></b-form-select>
                                                <b-input-group-prepend><span class="input-group-text" style="width:60px;">{{model.matauang}}</span></b-input-group-prepend>
                                                <my-number  class="form-control text-right" v-model="apLinesObj.nilaipphAdj" :precision="2" :readonly="(calcPPh===1)"></my-number>
                                            </b-input-group>                                          
                                        </b-col>
                                    </b-row>
                                </b-col>
                            </b-row>
                        </b-tab>
                        <b-tab title="INVOICE ITEM DIMENSION">
                            <b-row>
                                <b-col lg="8" xl="6"  class="pl-0">
                                    <v-dim :model="apLinesObj" :key="updateDimDtl"></v-dim>
                                </b-col>
                            </b-row>
                        </b-tab>
                      </b-tabs>
                        <b-row class="justify-content-center mt-1">
                            <b-button v-if="saveEnabled" class="btn btn-info mr-1" @click="saveApLines()">Update</b-button>
                            <b-button class="btn btn-warning ml-1" @click="row.toggleDetails">Cancel</b-button>
                        </b-row>
                    </b-card>
                    </template>                        
                </b-table>
                <b-row class="mt-1">
                    <b-col cols="5">
                        <b-row>
                            <div class="ml-5">
                                Showing {{((apLines.page - 1) * apLines.limit + 1)}}
                                to <span v-if="((apLines.page * apLines.limit)>apLines.total)">{{apLines.total}}</span>
                                    <span v-else>{{apLines.page * apLines.limit}}</span>
                                <strong> of {{apLines.total}} entries </strong>
                            </div>    
                        </b-row>                    
                    </b-col>
                    <b-col cols="2">
                            <b-input-group>
                                <b-input-group-prepend><span class="ml-4 pt-1 mr-2">Limit per page</span></b-input-group-prepend>
                                <b-form-select :options="[5, 10, 15, 20, 25]" :plain="true" v-model="apLines.limit"  style="width:80px;"/>
                            </b-input-group>
                    </b-col>
                    <b-col cols="5">
                        <b-pagination
                            align="right"
                            :total-rows="apLines.total"
                            :per-page="apLines.limit"
                            v-model="apLines.page"
                        ></b-pagination>
                    </b-col>
                </b-row>
            </b-card>    

            <b-row align-h="between" class="mt-1">
                    <b-col lg="4">
                        <h5>Before Correction/Adjustment</h5>
                        <b-input-group v-if="(model.matauang !== uanguser)" >
                            <b-input-group-prepend><label>TAX Exch.Rate {{model.matauang}}</label></b-input-group-prepend>
                            <b-input-group-prepend>
                            <span class="input-group-text" style="width:60px;">{{uanguser}}</span>
                            </b-input-group-prepend>
                            <my-number :disabled="(model.matauang === uanguser)" class="form-control text-right" separator="," v-model="model.kursppnAdj" ></my-number>
                        </b-input-group>
                        <b-input-group >
                            <b-input-group-prepend><label >Subtotal</label></b-input-group-prepend>
                            <b-input-group-prepend>
                                <span class="input-group-text" style="width:60px;">{{model.matauang}}</span>
                            </b-input-group-prepend>
                            <my-number class="form-control text-right" v-model="model.ttlnetto" :precision="2" disabled></my-number>
                        </b-input-group>
                        <b-input-group >
                            <b-input-group-prepend><label >DP</label></b-input-group-prepend>
                            <b-input-group-prepend>
                                <span class="input-group-text" style="width:60px;">{{model.matauang}}</span>
                            </b-input-group-prepend>
                            <my-number class="form-control text-right bg-danger" v-model="model.nilaidp" :precision="2" disabled></my-number>
                        </b-input-group>
                        <b-input-group >
                            <b-input-group-prepend>
                            <b-input-group-prepend><label >VAT(PPN)</label></b-input-group-prepend>
                            </b-input-group-prepend>
                            <b-input-group-prepend>
                                <span class="input-group-text" style="width:60px;">{{model.matauang}}</span>
                            </b-input-group-prepend>
                            <my-number class="form-control text-right" v-model="model.nilaippn" :precision="2" :readonly="(calcVAT===1)"></my-number>
                        </b-input-group>
                        <b-input-group >
                            <b-input-group-prepend><label >Total Amount Due</label></b-input-group-prepend>
                            <b-input-group-prepend>
                                <span class="input-group-text" style="width:60px;">{{model.matauang}}</span>
                            </b-input-group-prepend>
                            <my-number class="form-control text-right" v-model="model.totalinv_dp" :precision="2" disabled></my-number>
                        </b-input-group>
                        <b-input-group >
                            <b-input-group-prepend><label >W/H Tax (PPH)</label></b-input-group-prepend>
                            <b-input-group-prepend>
                                <span class="input-group-text" style="width:60px;">{{model.matauang}}</span>
                            </b-input-group-prepend>
                            <my-number class="form-control text-right" v-model="model.totalpph" :precision="2" disabled></my-number>
                        </b-input-group>
                        <b-input-group >
                            <b-input-group-prepend ><label>&nbsp;</label></b-input-group-prepend>
                            <b-form-checkbox id="chkGrossUp" class="ml-2 mt-2" v-model="model.grossup" value=1 unchecked-value=0 disabled> 
                                Gross Up W/H Tax(PPh)
                            </b-form-checkbox>
                        </b-input-group>
                        <b-input-group >
                            <b-input-group-prepend><label >Total AP</label></b-input-group-prepend>
                            <b-input-group-prepend>
                                <span class="input-group-text" style="width:60px;">{{model.matauang}}</span>
                            </b-input-group-prepend>
                            <my-number class="form-control text-right" v-model="model.totalap_dp" :precision="2" disabled></my-number>
                        </b-input-group>
                    </b-col>
                    <b-col lg="4">
                        <b-input-group class="mt-4" >
                            <b-input-group-prepend><label>TAX Correction Date</label></b-input-group-prepend>
                            <b-form-input v-model="model.tanggalAdj" type="date" :state="!$v.model.tanggalAdj.$error"></b-form-input>                                        
                        </b-input-group>
                        <!-- <b-input-group >
                            <b-input-group-prepend><label>Jenis Transaksi</label></b-input-group-prepend>
                              <b-form-select  :plain="true" :options="['SERVICE','MATERIAL']"></b-form-select>
                        </b-input-group> -->
                        <b-input-group>
                            <b-input-group-prepend><label>No. Faktur PPN</label></b-input-group-prepend>
                            <b-form-input v-model="model.nofaktur" :state="!$v.model.nofaktur.$error"></b-form-input>
                        </b-input-group>
                        <b-input-group >
                            <b-input-group-prepend><label>Tgl. Faktur PPN</label></b-input-group-prepend>
                            <b-form-input v-model="model.tglfaktur" type="date" :state="!$v.model.tglfaktur.$error"></b-form-input>
                        </b-input-group>
                        <b-input-group >
                            <b-input-group-prepend><label>Invoice No.</label></b-input-group-prepend>
                            <b-form-input v-model="model.invoice" :state="!$v.model.invoice.$error"></b-form-input>
                        </b-input-group>
                        <b-input-group >
                            <b-input-group-prepend><label>Invoice Date</label></b-input-group-prepend>
                            <b-form-input v-model="model.invdate" type="date"></b-form-input>
                        </b-input-group>
                        <b-input-group >
                            <b-input-group-prepend><label>Invoice Due Date</label></b-input-group-prepend>
                            <b-form-input v-model="model.duedate" type="date"></b-form-input>
                        </b-input-group>
                        <b-row class="justify-content-center mb-2">
                            <button  v-if="saveEnabled" class="btn btn-primary mr-1" @click="save()"><i class="fa fa-save"></i> Save</button>
                            <button class="btn btn-primary" @click="close()" > <i class="fa fa-close"></i> Close</button>
                        </b-row>

                    </b-col>

                    <b-col lg="4">
                        <h5>After Correction/Adjustment</h5>
                        <div class="text-right">
                            <b-input-group >
                                <b-input-group-prepend ><label style="text-align: left;width:80px; padding-left:16px;">&nbsp;</label></b-input-group-prepend>
                                <b-form-checkbox  v-model="model.taxliableAdj" value=1 unchecked-value=0  class="ml-2 mt-2  mr-2">VAT(PPN) dikreditkan</b-form-checkbox>
                                <b-form-checkbox  class="ml-2 mt-2" v-model="model.ppndisetor" value=1 unchecked-value=0 @change="calcAmountDue">
                                    VAT (PPN) disetor sendiri
                                </b-form-checkbox>
                            </b-input-group>
                            <b-input-group >
                                <b-input-group-prepend><label style="text-align: left; width:158px; padding-left:16px;">subtotal</label></b-input-group-prepend>
                                <b-input-group-prepend>
                                    <span class="input-group-text" style="width:60px;">{{model.matauang}}</span>
                                </b-input-group-prepend>
                                <my-number class="form-control text-right" v-model="model.ttlnetto" :precision="2" disabled></my-number>
                            </b-input-group>
                            <b-input-group >
                                    <b-input-group-prepend><label style="text-align: left; width:158px; padding-left:16px;">DP</label></b-input-group-prepend>
                                <b-input-group-prepend>
                                    <span class="input-group-text" style="width:60px;">{{model.matauang}}</span>
                                </b-input-group-prepend>
                                <my-number class="form-control text-right bg-danger" v-model="model.nilaidp" :precision="2" disabled></my-number>
                            </b-input-group>
                            <b-input-group >
                                <b-input-group-prepend>
                                <b-form-select style="width:158px; font-size:small;"  v-model="calcVAT" :plain="true" :options="calcuationVAT" @change="calcAmountDue"></b-form-select>
                                </b-input-group-prepend>
                                <b-input-group-prepend>
                                    <span class="input-group-text" style="width:60px;">{{model.matauang}}</span>
                                </b-input-group-prepend>
                                <my-number class="form-control text-right" v-model="model.nilaippnAdj" :precision="2" :readonly="(calcVAT===1)"></my-number>
                            </b-input-group>

                            <b-input-group >
                                <b-input-group-prepend><label style="text-align: left;width:158px; padding-left:16px;">Total Amount Due</label></b-input-group-prepend>
                                <b-input-group-prepend>
                                    <span class="input-group-text" style="width:60px;">{{model.matauang}}</span>
                                </b-input-group-prepend>
                                <my-number class="form-control text-right" v-model="model.totalinvAdj_dp" :precision="2" disabled></my-number>
                            </b-input-group>
                            <b-input-group >
                                <b-input-group-prepend><label style="text-align: left;width:158px; padding-left:16px;">W/H Tax (PPH)</label></b-input-group-prepend>
                                <b-input-group-prepend>
                                    <span class="input-group-text" style="width:60px;">{{model.matauang}}</span>
                                </b-input-group-prepend>
                                <my-number class="form-control text-right" v-model="model.totalpphAdj" :precision="2" disabled></my-number>
                            </b-input-group>
                            <b-input-group v-if="(model.totalpphAdj)">
                                <b-input-group-prepend ><label style="text-align: left;width:80px; padding-left:16px;">&nbsp;</label></b-input-group-prepend>
                                <b-form-checkbox id="chkGrossUpAdj" class="ml-2 mt-2 mr-2" v-model="model.grossupAdj" value=1 unchecked-value=0 @change="calcAmountDue">
                                    Gross Up W/H Tax(PPh)
                                </b-form-checkbox>
                                <b-input-group-prepend v-if="(model.grossupAdj==0)"><span class="p-2">Disetor Sendiri</span></b-input-group-prepend>
                                <b-form-input v-if="(model.grossupAdj==0)" v-model="model.pphdisetorpc" @change="calcAmountDue" type="number" ></b-form-input>
                                <b-input-group-append v-if="(model.grossupAdj==0)"><span class="input-group-text">%   {{model.pphdisetorval}}</span></b-input-group-append>
                            </b-input-group>
                            <b-input-group >
                                <b-input-group-prepend><label style="text-align: left;width:158px; padding-left:16px;">Total AP</label></b-input-group-prepend>
                                <b-input-group-prepend>
                                    <span class="input-group-text" style="width:60px;">{{model.matauang}}</span>
                                </b-input-group-prepend>
                                <my-number class="form-control text-right" v-model="model.totalapAdj_dp"  :precision="2" disabled></my-number>
                            </b-input-group>

                        </div>
                    </b-col>
               </b-row>
        </b-card>
        <b-modal v-model="lkuApShow" size="lg" :hide-footer="true" title="List of AP Outstanding(POSTED)" :centered="true" :lazy="true">
            <lku-ap @click="onSelectLkuAp" :formdata="lkuApData" posted="1"></lku-ap>
        </b-modal>        
        <b-modal v-model="lkuCoaShow" size="lg" :hide-footer="true" title="List of GL Account" :centered="true">
            <lku-coa @click="onSelectLkuCoa" :tahun="tahun" :key="tahun"></lku-coa>
        </b-modal>      
        <b-modal v-model="lkuObjekpphShow" size="lg" :hide-footer="true" title="Daftar Kode Bukti Potong(Objek Pajak)" :centered="true">
            <lku-objekpph @click="onSelectLkuObjekpph"></lku-objekpph>
        </b-modal>        
    <loading :active.sync="isLoading" :height="128" :width="128" color="#4b8cf4" ></loading>       

    </div>
</template>
<style lang="scss">
    .apinvfrm {
        .input-group {
            padding-bottom:2px;
            .input-group-prepend {
                label {
                    padding-top: 5px;
                    padding-right: 5px;
                    width: 130px;
                }
            }
        }
        .form-group {
            margin-bottom:2px;
            .input-group {
                padding-bottom:0;
            }
        }
        .row-details-form {
            label {
            text-align: right !important;
            }
            legend {
            text-align: right !important;;
            }
        }
    }
</style>

<script>
import Loading from 'vue-loading-overlay';
import 'vue-loading-overlay/dist/vue-loading.css';
import toastr from "mini-toastr";
import moment from 'moment';
import myNumber from "../../components/my-number";
import vDim from "../lookup/dimReadonly";
import lkuAp from "../lookup/lkuApLazzy";
import lkuCoa from "../lookup/lkuCoa";
import lkuObjekpph from "../lookup/lkuObjekpph";
import aptaxadjust from "../../apis/aptaxadjust";
import apinv from "../../apis/apinv";
import { validationMixin } from "vuelidate";
import { required,  minValue } from "vuelidate/lib/validators";
toastr.init();

export default {   
  components: { Loading, myNumber, vDim, lkuAp ,lkuCoa,lkuObjekpph},
  mixins: [validationMixin],
  validations: {
        model: {
            apinvkey: { required },
            uraian: { required },
            tanggalAdj: { required },
            invoice: { required },
            matauang: { required },
            nofaktur: {required : (function() {
                if ((this.model.nilaippn || 0) == 0) {
                    return true;
                } else if ((this.model.nofaktur || '')==''){
                    return false;
                } else return true;
            })},
            tglfaktur: {required : (function() {
                if ((this.model.nilaippn || 0) == 0) {
                    return true;
                } else if (!(this.model.tglfaktur)){
                    return false;
                } else return true;
            })},
            totalinv: { required, minValue:minValue(1) },
            kursppnAdj: {required : (function() {
                if ((this.model.nilaippnAdj || 0) == 0) {
                    this.model.kursppnAdj=this.model.kursppnAdj || 1;
                    return true;
                } else if (this.model.matauang == this.uanguser){
                    this.model.kursppnAdj=1;
                    return true;
                } else if ((this.model.kursppnAdj || 0) == 0){
                    return false;
                } else return true;
            })},

            totalinvAdj: { required, minValue:minValue(1) },
        },
        apLinesObj: {
            // kodeacc: { required },
            // uraian_dt: { required },
            // quantity: { numeric },
            // unitprice: { numeric },
            // nilai: { numeric },
            // kenappnAdj: { required },
            pasalpphAdj: {required : (function() {
                if ((this.apLinesObj.nilaipphAdj || 0) == 0) {
                    return true;
                } else if (((this.apLinesObj.pasalpphAdj || '')=='') || (this.apLinesObj.pasalpphAdj== 'N/A') || (this.apLinesObj.pasalpphAdj== 'NO WHT')){
                    return false;
                } else return true;
            })},
        },
  }, 
  data() {
    return {
        watching_pasalpph:true,            
        isLoading:false,
        saveEnabled:true,
        lkuApShow: false,
        lkuObjekpphShow: false,
        updateDimHdr:false,
        updateDimDtl:true,
        tarifPPN: this.$store.state.user.tarifppn || 10,
        tahun:(this.$store.state.user.tglaktif || '').substring(0,4),
        uanguser: this.$store.state.user.matauang,
        postGroups:[],
        currency:[{value:'IDR',text:'IDR'}],
        invoiceTerms: [{ value: '', text: '-' }, { value: 'Term#1', text: 'Term#1' }, { value: 'Term#2', text: 'Term#2' },
                { value: 'Term#3', text: 'Term#3' }, { value: 'Term#4', text: 'Term#4' }
        ],
        calcVAT:1,
        calcuationVAT : [{ value: 1, text: 'VAT (Auto Calc)' }, { value: 0, text: 'VAT (Manual Calc)' }],
        calcPPh:1,
        calcuationPPH : [{ value: 1, text: 'Nilai PPH(Otomatis)' }, { value: 0, text: 'Nilai PPH(Manual)' }],
        lookupPPH:[],
        YesNo :   [{ value: 1, text: 'YES' }, { value: 0, text: 'NO' }],
        model: {
            apinvkey:'',
            vendor: '',
            po: '',
            uraian: '',
            tanggal: moment().format('YYYY-MM-DD'),
            postgroup: '',
            kodecash: '',
            matauang: 'IDR',
            tagihandp: 0,
            termin: '',
            nofaktur: '',
            tglfaktur: '',
            totalinv: 0, nilaippn:0,grossup:0,nilaippnAdj:0,grossupAdj:0,
            kursppnAdj: 1, kursppn:1, DimTableKey:'',
            ppndisetor:0, pphdisetorpc:0,pphdisetorval:0,  
            taxliable:1, taxliableAdj:0
        },
        apLines: {
            items: [],
            selected:{},
            fields: [
                {key: 'index', label: 'No.' ,thStyle: "width:40px"},
                {
                    key: "uraian_dt",
                    label: "Description",
                },
                {
                    key: "glAccount",
                    label: "GL Account"
                },
                {
                    key: "quantity",
                    label: "Quantity",
                    thStyle: "width:90px",
                },
                {
                    key: "unitprice",
                    label: "Unit price",
                    thStyle: "width:120px",
                    thClass: "text-right",
                    tdClass: "text-right"
                },
                {
                    key: "nilai",
                    label: "Amount NETT",
                    thStyle: "width:140px",
                    thClass: "text-right",
                    tdClass: "text-right"
                },
                {
                    key: "nilaippn",
                    label: "Amount VAT",
                    thStyle: "width:120px",
                    thClass: "text-right",
                    tdClass: "text-right"
                },
                {
                    key: "nilaidue",
                    label: "Amount DUE",
                    thStyle: "width:140px",
                    thClass: "text-right",
                    tdClass: "text-right"
                },
                {
                    key: "pasalpph",
                    label: "PPH",
                    thStyle: "width:90px",
                    thClass: "text-center",
                    tdClass: "text-center"
                },
                {
                    key: "action",
                    label: "Action",
                    thStyle: "width:60px",
                    thClass: "text-center",
                },
            ],
            page: 1,
            limit: 15,
            total: 0,
        },
        apLinesObj: {
            kodeacc: '',glAccount:'',
            uraian_dt: '',
            quantity: 0,
            unitprice: 0,
            nilai: 0,
            nilaippnAdj: 0,
            kenappnAdj: 0,
            pasalpphAdj: 'NO WHT', 
            pphAdj: 0, unitzise:'', DimTableKey:''
        },
        tabIndex:0,
        lkuCoaShow:false,
        saveClick:false,
        lkuApData:[]
    };
},
  computed: {
    dimension(){
      return this.$store.state.dimension;
    },
    invalidApLines() {
      this.$v.apLinesObj.$touch();
      return this.$v.apLinesObj.$invalid;
    },
    invalidModel() {
      this.$v.model.$touch();
      return this.$v.model.$invalid;
    },
    use_procure(){
        return (this.$store.state.user.use_procure == 1);
    },
    noPPN(){
        return (this.model.nilaippnAdj == 0);
    },
    unitprice(){
        return this.apLinesObj.unitprice;
    },
    pasalpph(){
        return this.apLinesObj.pasalpphAdj;
    },    
  },
  watch: {
    unitprice: function(newval) {
        setTimeout(() => {
            this.calcPrice();
        }, 100);
    },    
    pasalpph: function(newval) {
        if (this.watching_pasalpph==true) {
            const item = this.lookupPPH.find(p => p.value==newval);
            if (item) {
                this.apLinesObj.pphAdj=item.pph;
                setTimeout(() => {
                    this.calcTaxes();
                }, 100);
            }
        }
    },    
    noPPN: function(newval) {
        if (newval) {
            this.model.nofaktur='';
            this.model.tglfaktur='';
        }
    },    
  },
  created: async function(){
      if (this.$route.params.taxadjkey)  {
          toastr.info('Loading AP Detail, please wait')
          try {
            const [a,b,c,data] = await Promise.all([aptaxadjust.postgroup(), aptaxadjust.pasalpph(),aptaxadjust.currency(),aptaxadjust.detail(this.$route.params)]) ;
            this.postGroups = a;
            this.lookupPPH = b;
            this.currency = c;
            // const data = await aptaxadjust.detail(this.$route.params);  
            const row = data[0][0];
            this.saveEnabled=(row.posting === 0);
            row.tanggal = row.tanggal ? moment(row.tanggal).format('YYYY-MM-DD') : '';
            row.tanggalAdj = row.tanggalAdj ? moment(row.tanggalAdj).format('YYYY-MM-DD') : '';
            row.invdate = row.invdate ? moment(row.invdate).format('YYYY-MM-DD') : '';
            row.duedate = row.duedate ? moment(row.duedate).format('YYYY-MM-DD') : '';
            row.tglfaktur = row.tglfaktur ? moment(row.tglfaktur).format('YYYY-MM-DD') : '';
            for (var key in row) {
                this.model[key] = row[key];
            }
            this.model.totalap_dp = row.totalap - row.nilaidp;
            this.model.totalapAdj_dp = row.totalapAdj - row.nilaidp;
            this.model.totalinv_dp= row.totalinv- row.nilaidp; 
            this.model.totalinvAdj_dp= row.totalinvAdj- row.nilaidp; 
            this.model.totaldpp= this.model.ttlnetto-this.model.nilaidp;

            this.calcVAT=row.calcVAT||1;
            this.model.taxliable= this.model.taxliable || 1;
            this.model.taxliableAdj= this.model.taxliableAdj || 0;

            this.apLines.items = data[1];
            this.apLines.total=this.apLines.items.length;
            this.calcTotalDtlAp();
            this.tanggalBerubah();
            this.updateDimHdr = !this.updateDimHdr;
            // this.$forceUpdate();
            toastr.clear;
          } catch (error) {
                console.log('error : ', error);
                toastr.error(JSON.stringify(error), "ERROR MESSAGE");                              
          }
      } else  if (this.$route.params.apinvkey) {
            const [a,b,c, data] = await Promise.all([aptaxadjust.postgroup(), aptaxadjust.pasalpph(),aptaxadjust.currency(),apinv.detail(this.$route.params)]) ;
            this.postGroups = a;
            this.lookupPPH = b;
            this.currency = c;
            this.model.tanggalAdj = '';
            const row = data[0][0];
            row.tanggal = row.tanggal ? moment(row.tanggal).format('YYYY-MM-DD') : '';
            row.invdate = row.invdate ? moment(row.invdate).format('YYYY-MM-DD') : '';
            row.duedate = row.duedate ? moment(row.duedate).format('YYYY-MM-DD') : '';
            row.tglfaktur = row.tglfaktur ? moment(row.tglfaktur).format('YYYY-MM-DD') : '';
            for (var key in row) {
                this.model[key] = row[key];
            }
            // this.model.nettApAdj= row.nettApAdj, 
            this.model.totalinvAdj= row.totalinv; 
            this.model.nilaidppAdj= row.nilaidpp; 
            this.model.ppnAdj= row.ppn; 
            this.model.kursppnAdj= row.kursppn; 
            this.model.nilaippnAdj= row.nilaippn; 
            this.model.grossupAdj= row.grossup; 
            this.model.kurspphAdj= row.kurspph; 
            this.model.totalpphAdj= row.totalpph; 
            this.model.totalap_dp = row.totalap - row.nilaidp;
            this.model.totalapAdj_dp = row.totalap - row.nilaidp;
            this.model.totalinv_dp= row.totalinv- row.nilaidp; 
            this.model.totalinvAdj_dp= row.totalinv- row.nilaidp; 
            this.model.taxliableAdj=1;
            this.apLines.items = data[1];
            this.apLines.total=this.apLines.items.length;
            this.apLines.items.forEach((line)=>{
                line.kenappnAdj=line.kenappn;
                line.dppnlainAdj= line.dppnlain;
                line.dppAdj= line.dpp;
                line.nilaippnAdj = line.nilaippn;
                line.nilaidueAdj = line.nilaidue;
                line.pasalpphAdj= line.pasalpph;
                line.pphAdj= line.pph; 
                line.nilaipphAdj= line.nilaipph;
            });
            this.saveEnabled=false;
      } else {
        const [a,b,c] = await Promise.all([aptaxadjust.postgroup(), aptaxadjust.pasalpph(),aptaxadjust.currency()]) ;
        this.postGroups = a;
        this.lookupPPH = b;
        this.currency = c;
        this.model.tanggalAdj = moment().format('YYYY-MM-DD');
      }
  },
  methods: {
    onSelectLkuObjekpph(_selected) {
        this.apLinesObj.penghasilan = _selected.penghasilan.trim();
        this.apLinesObj.jenisphs = _selected.jenisphs;
        this.apLinesObj.penghasilaninfo = `${this.apLinesObj.jenisphs} | ${this.apLinesObj.penghasilan}`;
        this.lkuObjekpphShow=false;
    },       

    async onSelectLkuAp(invLookup) {
            const data = await apinv.detail(invLookup.selected);  
            const row = data[0][0];
            row.tanggal = row.tanggal ? moment(row.tanggal).format('YYYY-MM-DD') : '';
            row.invdate = row.invdate ? moment(row.invdate).format('YYYY-MM-DD') : '';
            row.duedate = row.duedate ? moment(row.duedate).format('YYYY-MM-DD') : '';
            row.tglfaktur = row.tglfaktur ? moment(row.tglfaktur).format('YYYY-MM-DD') : '';
            for (var key in row) {
                this.model[key] = row[key];
            }
            // this.model.nettApAdj= row.nettApAdj, 
            this.model.totalinvAdj= row.totalinv; 
            this.model.nilaidppAdj= row.nilaidpp; 
            this.model.ppnAdj= row.ppn; 
            this.model.kursppnAdj= row.kursppn; 
            this.model.nilaippnAdj= row.nilaippn; 
            this.model.grossupAdj= row.grossup; 
            this.model.kurspphAdj= row.kurspph; 
            this.model.totalpphAdj= row.totalpph; 
            this.model.totalap_dp = row.totalap - row.nilaidp;
            this.model.totalapAdj_dp = row.totalap - row.nilaidp;
            this.model.totalinv_dp= row.totalinv- row.nilaidp; 
            this.model.totalinvAdj_dp= row.totalinv- row.nilaidp; 
            this.model.taxliableAdj=1;
            this.apLines.items = data[1];
            this.apLines.total=this.apLines.items.length;
            this.apLines.items.forEach((line)=>{
                line.kenappnAdj=line.kenappn;
                line.dppnlainAdj= line.dppnlain;
                line.dppAdj= line.dpp;
                line.nilaippnAdj = line.nilaippn;
                line.nilaidueAdj = line.nilaidue;
                line.pasalpphAdj= line.pasalpph;
                line.pphAdj= line.pph; 
                line.nilaipphAdj= line.nilaipph;
                line.penghasilaninfo = `${line.jenisphs} | ${line.penghasilan}`;
            });

        this.lkuApShow=false;
        this.lkuApData=invLookup;
    },
    calcPrice : function() {
        this.apLinesObj.nilai = parseFloat(this.apLinesObj.quantity) * parseFloat((this.apLinesObj.unitprice || 0));
        this.calcTaxes();
    },
    calcTaxes : function() {
        this.apLinesObj.kenappnAdj = this.apLinesObj.kenappnAdj || 0;
        this.apLinesObj.dppnlainAdj=this.apLinesObj.dppnlainAdj || 100; 
        this.apLinesObj.nilainett = this.apLinesObj.nilai;
        this.apLinesObj.dppAdj = parseFloat(this.apLinesObj.nilainett) * parseFloat(this.apLinesObj.dppnlainAdj) / 100;
        this.model.ppn = this.model.ppn || this.tarifPPN;
        if (this.apLinesObj.kenappnAdj == 1) {
            this.model.grossup = 0;
            this.apLinesObj.nilaippnAdj = (this.model.ppn/100) * this.apLinesObj.dppAdj;
        } else {
            this.apLinesObj.nilaippnAdj = 0;
        }
        if (this.model.grossup == 1)
            this.apLinesObj.dppAdj = this.apLinesObj.dppAdj * (100 / (100 - this.apLinesObj.pph));

        this.apLinesObj.nilaidueAdj = this.apLinesObj.nilainett + this.apLinesObj.nilaippnAdj;
        if (this.calcPPh == 1){
            this.apLinesObj.nilaipphAdj = this.apLinesObj.dppAdj * parseFloat(this.apLinesObj.pphAdj) / 100;
        }
        this.calcAmountDue();
        // this.$forceUpdate();
    },
    calcAmountDue : function() {
        setTimeout(() => {
            if (this.model.ppndisetor==1) {
                    this.model.totalinvAdj = parseFloat(this.model.ttlnetto || 0) - parseFloat(this.model.nilaippn || 0);
            } else {
                this.model.totalinvAdj = parseFloat(this.model.ttlnetto || 0) + parseFloat(this.model.nilaippnAdj || 0);
            }
            this.model.totalinvAdj_dp=this.model.totalinvAdj-this.model.nilaidp;
            if (this.model.grossupAdj==0) {
                if (this.model.pphdisetorpc != 0){
                    this.model.pphdisetorval= (this.model.pphdisetorpc/100)*this.model.totalpphAdj;
                }
            } else {
                this.model.pphdisetorpc =0;
                this.model.pphdisetorval= 0;
            }

            if (this.model.grossupAdj==1) {
                // toastr.info('masuk this.model.grossupAdj==1');
                this.model.totalapAdj = this.model.totalinvAdj;
                
            } else {
                // toastr.info('masuk this.model.grossupAdj==0');
                this.model.totalapAdj = this.model.totalinvAdj-(this.model.totalpphAdj-this.model.pphdisetorval);
            }
            this.model.totalapAdj_dp = this.model.totalapAdj-this.model.nilaidp;

            this.model.nettApAdj = this.model.totalapAdj-this.model.totalap;
            // console.log('row.nettApAdj : ',this.model.nettApAdj);
            this.$forceUpdate();
            
        }, 200);
    },    

    onSelectLkuCoa(_selected) {
        this.apLinesObj.glAccount = _selected.kodeacc.trim() + ' | ' + _selected.namaacc.trim();
        this.apLinesObj.kodeacc = _selected.kodeacc;
        this.apLinesObj.namaacc = _selected.namaacc;
        this.dimension.forEach((dim) => {
            if (_selected[dim.value]) {
                this.apLinesObj[dim.value] = _selected[dim.value];
                this.apLinesObj[`${dim.value}Txt`] = _selected[`${dim.value}Txt`];
                this.apLinesObj[`${dim.value}Info`] = _selected[`${dim.value}Info`];
                // this.apLinesObj[`${dim.value}Info`] = _selected[dim.value] + ' | '+ _selected[`${dim.value}Txt`];
            }
        });        

        this.lkuCoaShow=false;
    },
    closeApLines: function(){
        const opened= this.apLines.items.find( r=> r._showDetails==true);
        if (opened) opened._showDetails=false;
    },
    editApLines : function (obj,callback) {
        this.closeApLines();
        this.apLines.selected = obj;
        this.watching_pasalpph=false;            
        this.apLinesObj.kodeacc= '';
        this.apLinesObj.uraian_dt= '';
        this.apLinesObj.quantity= 0;
        this.apLinesObj.unitprice= 0;
        this.apLinesObj.nilai= 0;
        this.apLinesObj.nilaippnAdj= 0;
        this.apLinesObj.kenappnAdj= 0;
        this.apLinesObj.pasalpphAdj= 'NO WHT'; 
        this.apLinesObj.pphdisetorpc=0; 
        this.apLinesObj.pphAdj= 0; 
        this.apLinesObj.unitzise=''; 
        this.apLinesObj.DimTableKey='';
        this.calcPPh=obj.calcPph||1;
        for (var key in obj) {
            this.apLinesObj[key] = obj[key];
        }
        this.model.ppn= this.model.ppn || this.tarifPPN;
        this.apLinesObj.pph = this.apLinesObj.pph || 0;
        this.apLinesObj.dppnlainAdj= this.apLinesObj.dppnlainAdj || 100;
        this.apLinesObj.penghasilaninfo = `${this.apLinesObj.jenisphs} | ${this.apLinesObj.penghasilan}`;

        this.dimension.forEach((dim) => {
            if (obj[dim.value]) {
                this.apLinesObj[dim.value] = obj[dim.value];
                this.apLinesObj[`${dim.value}Txt`] = obj[`${dim.value}Txt`];
                this.apLinesObj[`${dim.value}Info`] = obj[dim.value] + ' | '+ obj[`${dim.value}Txt`];
            } else {
                this.apLinesObj[dim.value] = '';
                this.apLinesObj[`${dim.value}Txt`] = '';
                this.apLinesObj[`${dim.value}Info`] = '';
            }
        });
        this.tabIndex=0;
        setTimeout(() => {
            this.watching_pasalpph=true;            
        }, 300);
        callback();
    },
    delApLines: function (index) {
        if (index > -1) {
            // this.apLines.items.splice(index, 1);
            const posisi = (this.apLines.page-1)*this.apLines.limit;
            this.apLines.items.splice(posisi+index, 1);
        }
        this.apLines.total=this.apLines.items.length;
        this.calcTotalDtlAp();
    },
    saveApLines: async function (callback) {
        this.calcTaxes();
        if (this.invalidApLines) {
            console.log('validation : ', this.$v.apLinesObj);
            toastr.error('Please fill the form correctly.', "ERROR MESSAGE");
       } else {
            try {
                this.apLinesObj.kenappnAdj = this.apLinesObj.kenappnAdj || 0;
                for (var key in this.apLinesObj) {
                        this.apLines.selected[key] = this.apLinesObj[key];
                    }
                    this.apLines.total=this.apLines.items.length;
                    // this.updateDimDtl2Hdr(datadim);
                    this.calcTotalDtlAp();
                    this.apLines.selected._showDetails=false;
                    if (callback) callback();
            } catch (error) {
                console.log('error : ', error);
                if (error.message) {
                    toastr.error(error.message,'ERROR MESSAGE',10000);
                } else {
                    toastr.error(JSON.stringify(error),'ERROR MESSAGE',10000);
                }
            }
        }
    },
    save: async function () {
        if (!this.saveEnabled) {
            toastr.error('View mode cannot be Saved');
            this.isLoading=false;
            return;
        }
        this.isLoading=true;
        if (this.invalidModel) {
            console.log('validation : ', this.$v.model);
            console.log('model obj : ',this.model);
            toastr.error('Please fill the form correctly.', "ERROR MESSAGE");
            this.isLoading=false;    
        } else {        
            try {
                    this.calcAmountDue();
                    this.model.taxadjkey = this.model.taxadjkey || '';
                    this.model.nomor = this.model.nomor || '';
                    this.model.taxliableAdj= this.model.taxliableAdj || 0;
                    const row = {};
                    for (var key in this.model) {
                        row[key] = this.model[key];
                    }
                    row.tanggal = moment(row.tanggal).format('YYYY-MM-DD');
                    row.tanggalAdj = moment(row.tanggalAdj).format('YYYY-MM-DD');
                    row.invdate = row.invdate ? moment(row.invdate).format('YYYY-MM-DD') : undefined;
                    row.duedate = row.duedate ? moment(row.duedate).format('YYYY-MM-DD') : undefined;
                    row.tglfaktur = row.tglfaktur ? moment(row.tglfaktur).format('YYYY-MM-DD') : undefined;

                    // nettApAdj harus dihitung di AP saat save , isinya adalah net selisih TotalInv(incl.PPN) dan PPH dan GROSSUP        
                    // const totalap= (row.grossup==0) ? row.totalinv : row.totalinv-row.totalpph;
                    // const totalapAdj= (row.grossupAdj==0) ? row.totalinvAdj : row.totalinvAdj-row.totalpphAdj;
                    // row.nettApAdj = row.totalapAdj-row.totalap;
                    row.calcVAT=this.calcVAT;


                    let lineno=1;
                    let newApLines = this.apLines.items.reduce((newArr, item) => {
                        if ((item.kodeacc || '') != '') {
                            item.lineno = lineno;
                            newArr.push(item);
                            lineno += 1;
                        }
                        return newArr;
                    }, []);

                    row.lines = newApLines;
                    await aptaxadjust.save(row);
                    toastr.success("Complete successfully", "Save AP");
                    this.close();
            } catch (error) {
                this.isLoading=false;            
                console.log('error : ', error);
                if (error.sql) {
                    toastr.error(error.sql,'ERROR MESSAGE',10000);
                } else if (error.sqlMessage) {
                    toastr.error(error.sqlMessage,'ERROR MESSAGE',10000);
                } else if (error.message) {
                    toastr.error(error.message,'ERROR MESSAGE',10000);
                } else {
                    toastr.error(JSON.stringify(error),'ERROR MESSAGE',10000);
                }                   
            }

        }
    },
    updateDimDtl2Hdr: function (dimDtl) {
        var dimHdr = this.model;
        this.dimension.forEach((dim) => {
            if ((dimDtl[dim.value]) && !(dimHdr[dim.value])) {
                dimHdr[dim.value] = dimDtl[dim.value];
                dimHdr[`${dim.value}Txt`] = dimDtl[`${dim.value}Txt`];
                dimHdr[`${dim.value}Info`] = dimDtl[`${dim.value}Info`] ;
            }
        });
        this.updateDimHdr = !this.updateDimHdr;
    },
    updateDimHdr2Dtl: function (dimDtl) {
        var dimHdr = this.model;
        dimDtl = dimDtl || this.apLinesObj;
        this.dimension.forEach((dim) => {
            if ((dimHdr[dim.value]) && !(dimDtl[dim.value])) {
                dimDtl[dim.value] = dimHdr[dim.value];
                dimDtl[`${dim.value}Txt`] = dimHdr[`${dim.value}Txt`];
                dimDtl[`${dim.value}Info`] = dimHdr[`${dim.value}Info`] ;
            }
        });
        this.updateDimDtl = !this.updateDimDtl;
    },
    calcTotalDtlAp: function () {
        this.apLines.total=this.apLines.items.length;
        this.calcVAT = this.calcVAT || 1;
        let nilaippn = 0;
        let ttlnetto = 0;
        let totalpph = 0;
        let totaldpp=0;
        this.apLines.items.forEach( function (trx) {
            if (trx.kodeacc) {
                ttlnetto += (trx.nilai || 0);
                totaldpp += (trx.dppAdj || 0);
                nilaippn += (trx.nilaippnAdj || 0);
                totalpph += parseFloat(trx.nilaipphAdj || 0);                
            }
        });
        this.model.ttlnetto = ttlnetto;
        this.model.totaldpp= totaldpp;

        if (this.calcVAT == 1){
            if (this.model.nilaidp) {
                this.model.nilaippnAdj = (this.model.ppn/100) * (totaldpp - this.model.nilaidp);
            } else {
                this.model.nilaippnAdj = nilaippn;
            }
        }

        this.model.totalinvAdj = this.model.ttlnetto+this.model.nilaippnAdj;
        this.model.totalpphAdj = totalpph;
        // this.$forceUpdate();
        this.calcAmountDue();
    },
    tanggalBerubah: function(){
        this.tahun=moment(this.model.tanggal).format('YYYY');
    },
    close(){
      if ((this.$store.state.prevRoute.name) && (this.$store.state.prevRoute.name !== 'taxadmin.aptaxadjustfrm')) {
        router.push({name:this.$store.state.prevRoute.name});
      } else {
        // router.push({name:'taxadmin.aptaxadjust'});
          router.push("home");
      }
    }
  }
};
</script>
